import { asyncRouterMap, constantRouterMap } from '../../router'
import { deepClone } from '../../utils'

/**
 * 通过meta.functions判断是否与当前用户权限匹配
 */
function hasPermission(functions, route) {
  if (route.meta && route.meta.function) {
    return functions.some(fn => route.meta.function.indexOf(fn) >= 0)
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户权限的路由表
 * @param asyncRouterMap
 */
function filterAsyncRouter(asyncRouterMap, functions) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(functions, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, functions)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const user = {
  state: {
    // TODO: 放置初始状态
    authToken: null, // ajax token
    account: {}, // 账户信息
    toastList: [], // 系统提示
    modal: false, // 全局modal
    preloader: false, // preloader
    functions: [],
    addRouters: [],
    routers: constantRouterMap,
    name: null,
    selectedMenu: null
  },
  mutations: {
    // TODO: 放置我们的状态变更函数
    authToken(state, token) {
      state.authToken = token
    },
    preloader(state, status) {
      state.preloader = status
    },
    account(state, account) {
      state.account = account
    },
    modal(state, status) {
      state.modal = status
    },
    toast(state, json) {
      state.toastList.push(json)
      setTimeout(() => {
        state.toastList.shift()
      }, 2000)
    },
    setFunctions(state, functions) {
      state.functions = functions
    },
    setAddRouters(state, routers) {
      state.addRouters = deepClone(routers)
      // state.routers = deepClone(constantRouterMap.concat(routers))
    },
    switchMenu(state, path) {
      const routers = deepClone(constantRouterMap.concat(state.addRouters))
      let filteredRouters = routers.filter(_ => !_.hidden && path.indexOf(_.path) > -1)
      if (filteredRouters && filteredRouters.length > 0 && filteredRouters[0].children) {
        state.routers = filteredRouters[0].children
        state.selectedMenu = filteredRouters[0].path
      } else {
        filteredRouters = routers.filter(_ => !_.hidden)
        state.routers = filteredRouters[0].children
        state.selectedMenu = filteredRouters[0].path
      }
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { functions } = data
        let accessedRouters
        if (functions.indexOf(0) >= 0) {
          accessedRouters = asyncRouterMap
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, functions)
        }
        commit('setAddRouters', accessedRouters)
        resolve()
      })
    }
  }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js